import { render, staticRenderFns } from "./0.vue?vue&type=template&id=3a4720e9&scoped=true"
var script = {}
import style0 from "./0.vue?vue&type=style&index=0&id=3a4720e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4720e9",
  null
  
)

export default component.exports